<nz-select
  [nzLoading]="loading"
  nzMode="tags"
  nzPlaceHolder="select PM orders"
  [(ngModel)]="listOfOptions"
  [nzCustomTemplate]="custom"
  (ngModelChange)="selectionChanged($event)"
>
  <nz-option
    nzCustomContent
    *ngFor="let option of pmOrders$ | async; trackBy: trackByRef"
    [nzLabel]="option.orderNumber"
    [nzValue]="option"
  >
    <div>
      {{ option.orderType }}
    </div>
    <div>
      {{ option.orderTypeDescription }}
    </div>
    <div>
      {{ option.orderNumber }}
    </div>
  </nz-option>
</nz-select>

<ng-template #custom let-selected>
  <span>{{ selected.nzValue.orderType }} - {{ selected.nzValue.orderNumber }}</span>
</ng-template>
